import { Selector } from '@ngxs/store';
import _ from 'lodash';
import { HeadsetManufacturerType } from 'src/app/services/headset/headset-manufacturer-type';
import { AudioDevicesSettingsState, AudioDevicesSettingsStateModel, AudioSettings } from './audio-devices-settings.state';

export class AudioDevicesSettingsSelectors {
   @Selector([AudioDevicesSettingsState])
   public static getSettings(state: AudioDevicesSettingsStateModel): AudioSettings {
      return state.draftSettings ? state.draftSettings : state.currentSettings;
   }

   @Selector([AudioDevicesSettingsSelectors.getSettings])
   public static getRingerDeviceId(state: AudioSettings): string {
      return state?.ringerDeviceId;
   }

   @Selector([AudioDevicesSettingsSelectors.getSettings])
   public static getAudioInputDeviceId(state: AudioSettings): string {
      return state?.inputDeviceId;
   }

   @Selector([AudioDevicesSettingsSelectors.getSettings])
   public static getAudioOutputDeviceId(state: AudioSettings): string {
      return state?.outputDeviceId;
   }

   @Selector([AudioDevicesSettingsSelectors.getSettings])
   public static getHeadsetManufacturer(state: AudioSettings): HeadsetManufacturerType {
      if (_.isNil(state?.headsetManufacturerId)) {
         return HeadsetManufacturerType.NONE;
      }
      const item = HeadsetManufacturerType.find(state?.headsetManufacturerId);
      if (_.isNil(item)) {
         return HeadsetManufacturerType.NONE;
      }
      return item;
   }
}
